var _rect, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 38,
    viewBox: "0 0 88 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87,
    height: 37,
    fill: "white",
    stroke: "#97A0AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.0342 7.5C64.1365 7.50003 64.3421 7.55658 64.6729 7.76172C64.9903 7.95858 65.3699 8.25791 65.8057 8.65723C66.6762 9.45492 67.7241 10.6072 68.8867 12.0068C71.2097 14.8033 73.9491 18.5404 76.5732 22.2871C79.1957 26.0315 81.6969 29.7769 83.543 32.5869C84.4657 33.9915 85.2249 35.1622 85.7529 35.9814C85.877 36.174 85.9882 36.3478 86.0859 36.5H2.34668C2.82666 36.0881 3.45738 35.5476 4.20117 34.9189C5.94735 33.4431 8.31064 31.4761 10.7793 29.5098C13.2494 27.5423 15.8183 25.5813 17.9785 24.1143C19.0594 23.3802 20.0285 22.7758 20.8262 22.3574C21.225 22.1482 21.5728 21.9898 21.8643 21.8848C22.1627 21.7772 22.3707 21.7373 22.5 21.7373C22.8327 21.7373 23.2738 21.8452 23.8232 22.0713C24.3662 22.2947 24.9808 22.6189 25.6494 23.0176C26.9881 23.8159 28.4978 24.8841 30.0293 25.9678C31.5516 27.045 33.0964 28.1375 34.4756 28.96C35.1659 29.3716 35.8266 29.7233 36.4326 29.9727C37.0321 30.2193 37.6143 30.3818 38.1367 30.3818C38.4716 30.3817 38.8308 30.2468 39.1768 30.0684C39.535 29.8835 39.9365 29.621 40.3691 29.2998C41.2351 28.6569 42.273 27.7477 43.4189 26.6709C45.7122 24.516 48.4854 21.6453 51.2607 18.7891C54.0422 15.9265 56.8262 13.0777 59.1572 10.9443C60.3235 9.87696 61.3648 8.9991 62.2275 8.3916C62.6588 8.08792 63.0348 7.85902 63.3516 7.70801C63.6769 7.55293 63.8992 7.5 64.0342 7.5Z",
    fill: "#DADBDD",
    stroke: "#DADBDD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "matrix(-1 0 0 1 38 8)",
    fill: "#DADBDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderIcon);
export default __webpack_public_path__ + "static/media/placeholder_icon.e5619b6cd57ac6fbd2cd62b09a476831.svg";
export { ForwardRef as ReactComponent };